{/* Technical draft — must be reviewed by a legal professional before going live. */}

export function CompliancePage() {
  return (
    <div className="max-w-3xl mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Compliance-Richtlinie</h1>

      <div className="prose prose-sm max-w-none text-text-secondary space-y-6">
        <p>
          Die Compliance-Prüfung umfasst eine Verifikation der Identitat, der Vertretungsbefugnis,
          der Sanktionslistenkonformität sowie der wirtschaftlichen Leistungsfahigkeit des Hochstb
          ietenden.
        </p>

        <p>
          Die Plattform behält sich vor, den Zuschlag zu verweigern, wenn die Anforderungen nicht
          innerhalb der gesetzten Frist vollständig erfullt werden.
        </p>

        <h2 className="font-serif text-xl">1. Identifikation gem. GwG</h2>
        <p>Ausreichende Identifikationsmassnahmen gemass Geldwaschegesetz werden durchgefuhrt.</p>

        <h2 className="font-serif text-xl">2. Sanktionslistenprüfung</h2>
        <p>Abgleich gegen EU- sowie OFAC-Sanktionslisten.</p>

        <h2 className="font-serif text-xl">3. Vertretungsbefugnis</h2>
        <p>Nachweis durch Handelsregisterauszug.</p>

        <h2 className="font-serif text-xl">4. Wirtschaftliche Leistungsfahigkeit</h2>
        <p>Prüfung der Bonitat durch Bankbestatigung oder Nachweis der Verfugbarkeit des Kaufpreis
        .</p>

        <h2 className="font-serif text-xl">5. Verweigerungsrecht</h2>
        <p>Bei Nichterfullung innerhalb der Frist behalt sich die Plattform das Recht vor, den
        Zuschlag zu verweigern und an den nachstniedrigeren Bieter weiterzugeben.</p>
      </div>
    </div>
  );
}
